import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import {
  DeleteStatus, Duration, GuestType,
  ItemMode,
  MasterDataStatus,
  patchFormValue,
  REGEX
} from '../../../shared/shared.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProxyDynamicService } from '../../../shared/service/proxy-dynamic.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { distinctUntilChanged } from 'rxjs';
import { Promotion } from '../../../shared/models/promotion.model';

@Component({
  selector: 'app-service-package-item',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent implements AfterViewInit, OnInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formConfig = [];
  itemMode = ItemMode;
  formGroup!: FormGroup;
  mode = ItemMode.Add;
  listApartmentType: any[] = [];
  listDataService: any[] = [{ service_id: null, revenue_split_rate: null }];
  listDataServiceDeleted: any[] = [];
  listStatus: any[] = [];
  listOperate: any[] = [];
  listFrequency: any[] = [];
  listDuration: any[] = [];
  listGuestType: any[] = [];
  listService: any[] = [];
  listCost: any[] = [{ apartment_type: null, price_by_owner: null, price_by_guest: null }];
  listCostDeleted: any[] = [];
  regex = REGEX;
  expandCost = true;
  expandSale = true;
  expandPack = true;
  deleteStatus = DeleteStatus;
  Duration = Duration;
  objCache: any = null;

  get f() {
    return this.formGroup.controls;
  }

  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private service: ProxyDynamicService,
    private noti: NzNotificationService,
    private translateService: TranslateService,
  ) {
    this.formConfig = this.nzModalData.formConfig;
    this.listApartmentType = this.nzModalData.listApartmentType;
    this.listService = this.nzModalData.listService;
    this.listOperate = this.nzModalData.listOperate;
    this.listStatus = this.nzModalData.listStatus;
    this.listGuestType = this.nzModalData.listGuestType;
    this.listFrequency = this.nzModalData.listFrequency;
    this.listDuration = this.nzModalData.listDuration;
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      id: [undefined],
      code: [null, [Validators.required, Validators.pattern(this.regex.code)]],
      name: [null, Validators.required],
      note: [null],
      operation_type: [[]],
      discount: [null],
      tax: [null],
      free_nights_owner: [null],
      fund_value: [null],
      guest_type: [GuestType.Owner],
      frequency: [null],
      duration: [null],
      discount_for_owner: [null, [Validators.min(0), Validators.max(100)]],
      status: [MasterDataStatus.Active, Validators.required],
      service_apply: [[]],
      package_price: [[]],
      promotion_id: [undefined],
      details: [undefined],
      creator: [undefined],
      date_created: [undefined],
      updater: [undefined],
      date_updated: [undefined],
      allow_accumulation: [false],
    });
  }

  ngAfterViewInit() {
    this.mode = this.nzModalData.mode;
    if (this.nzModalData.mode === ItemMode.Add) {
      this.f['status'].disable();
      this.f['guest_type'].disable({ emitEvent: false });
      this.f['duration'].disable({ emitEvent: false });
    } else {
      const data = JSON.parse(JSON.stringify(this.nzModalData.data));
      this.listDataService = JSON.parse(JSON.stringify(data.service_apply.filter((r: any) => r.deleted === DeleteStatus.NO).map((item: any) => {
        item['service_id'] = item.service;
        return item;
      })));
      this.listCost = JSON.parse(JSON.stringify(data.package_price.filter((r: any) => r.deleted === DeleteStatus.NO)));
      data.operation_type = this.nzModalData.data.operation_type ? this.nzModalData.data.operation_type.split(',') : [];
      patchFormValue(this.formGroup, data);
      this.f['operation_type'].setValue(data.operation_type, { emitEvent: false });
      this.f['date_created'].setValue(data.date_created ? moment(data.date_created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
      this.f['date_updated'].setValue(data.date_updated ? moment(data.date_updated, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
      if (this.nzModalData.mode === ItemMode.View) {
        this.formGroup.disable({ emitEvent: false });
      } else {
        this.formGroup.enable({ emitEvent: false });
      }
      this.service.search('promotion_setting', {
        fields: ['*'],
        filter: { package_id: { '_eq': data.id } }
      }).then((res: any[]) => {
        if (res && res.length) {
          this.f['promotion_id'].setValue(res[0].id, { emitEvent: false })
          this.f['fund_value'].setValue(res[0].fund_value, { emitEvent: false });
          this.f['frequency'].setValue(res[0].frequency, { emitEvent: false });
          this.f['duration'].setValue(res[0].duration, { emitEvent: false });
          this.f['guest_type'].setValue(res[0].guest_type, { emitEvent: false });
          this.service.search('promotion_detail', {
            fields: ['*'],
            filter: { promotion_id: { '_eq': res[0].id }, deleted: { "_eq": DeleteStatus.NO } }
          }).then((res1: any[]) => {
            this.f['details'].setValue(res1.map((item: any) => {
              return {
                id: item.id,
                order: item.order,
                fund_value: item.fund_value
              }
            }), { emitEvent: false });
            setTimeout(() => {
              this.f['guest_type'].disable({ emitEvent: false });
              this.f['duration'].disable({ emitEvent: false });
              this.objCache = JSON.parse(JSON.stringify(this.formGroup.getRawValue()));
            })
          })
        }
      })
    }
    this.f['frequency'].valueChanges.pipe(distinctUntilChanged()).subscribe((value: any) => {
      this.f['duration'].setValue(value === Duration.MONTH ? value : Duration.YEAR);
      if (value === Duration.PRECIOUS) {
        const list: any[] = [];
        for (let i = 1; i <= 4; i++) {
          list.push({
            order: i,
            fund_value: this.f['fund_value'].value ? (i < 4 ? Math.round(this.f['fund_value'].value / 4) :
              this.f['fund_value'].value - list.reduce((a: number, b: any) => {
                return a + b.fund_value;
              }, 0)) : 0,
          })
        }
        this.f['details'].setValue(list);
      } else if (value === Duration.MONTH) {
        this.f['allow_accumulation'].setValue(false);
        this.f['details'].setValue({
          order: 1,
          fund_value: this.f['fund_value'].value,
        });
      } else {
        this.f['allow_accumulation'].setValue(false);
        this.f['details'].setValue(undefined);
      }
    });
    this.f['fund_value'].valueChanges.pipe(distinctUntilChanged()).subscribe((value: any) => {
      if (this.f['frequency'].value === Duration.PRECIOUS) {
        const list: any = [];
        const base = value ? Math.floor(value / 4) : 0;
        const remainder = value ? value - base * 4 : 0;
        for (let i = 1; i <= 4; i++) {
          list.push({
            order: i,
            fund_value: value ? base + (i <= remainder ? 1 : 0) : 0,
          });
        }
        this.f['details'].setValue(list);
      }
    });
    this.f['details'].valueChanges.pipe(distinctUntilChanged()).subscribe((value: any) => {
      console.log(value);
      // this.f['fund_value'].setValue()
    })
  }

  edit() {
    this.mode = ItemMode.Edit;
    const data = JSON.parse(JSON.stringify(this.nzModalData.data));
    data.operation_type = this.nzModalData.data.operation_type ? this.nzModalData.data.operation_type.split(',') : [];
    patchFormValue(this.formGroup, data);
    this.f['operation_type'].setValue(data.operation_type, { emitEvent: false });
    this.service.search('promotion_setting', {
      fields: ['*'],
      filter: { package_id: { '_eq': this.nzModalData.data.id } }
    }).then((res: any[]) => {
      if (res && res.length) {
        this.f['promotion_id'].setValue(res[0].id, { emitEvent: false })
        this.f['fund_value'].setValue(res[0].fund_value, { emitEvent: false });
        this.f['frequency'].setValue(res[0].frequency, { emitEvent: false });
        this.f['duration'].setValue(res[0].duration, { emitEvent: false });
        this.f['guest_type'].setValue(res[0].guest_type, { emitEvent: false });
        this.service.search('promotion_detail', {
          fields: ['*'],
          filter: { promotion_id: { '_eq': res[0].id }, deleted: { "_eq": DeleteStatus.NO } }
        }).then((res1: any[]) => {
          this.f['details'].setValue(res1.map((item: any) => {
            return {
              id: item.id,
              order: item.order,
              fund_value: item.fund_value
            }
          }), { emitEvent: false });
          this.f['date_created'].setValue(this.nzModalData.data.date_created ? moment(this.nzModalData.data.date_created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
          this.f['date_updated'].setValue(this.nzModalData.data.date_updated ? moment(this.nzModalData.data.date_updated, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
          this.formGroup.enable({ emitEvent: false });
          setTimeout(() => {
            this.f['guest_type'].disable({ emitEvent: false });
            this.f['duration'].disable({ emitEvent: false });
            this.objCache = JSON.parse(JSON.stringify(this.formGroup.getRawValue()));
          })
        })
      }
    })
  }

  destroyModal() {
    this.modal.destroy()
  }

  onSave() {
    const valid = this.validateTable();
    if (this.formGroup.valid && valid) {
      let listApplyService: any[] = [];
      let listPackagePrice: any[] = [];
      if (this.listCostDeleted.length) {
        listPackagePrice = this.listCostDeleted;
      }
      if (this.listDataServiceDeleted.length) {
        listApplyService = this.listDataServiceDeleted;
      }
      this.f['service_apply'].setValue(listApplyService.concat(this.listDataService).map(item => {
        return {
          ...item,
          revenue_split_rate: item.revenue_split_rate ?? 0
        }
      }));
      this.f['package_price'].setValue(listPackagePrice.concat(this.listCost));
      const body = this.formGroup.getRawValue();
      body.creator = undefined;
      body.updater = undefined;
      body.date_created = undefined;
      body.date_updated = undefined;
      body.free_nights_owner = undefined;
      body.operation_type = body.operation_type?.length ? body.operation_type.sort().join(',') : null;
      if (this.mode === ItemMode.Add) {
        body.id = undefined;
        body.promotion = {
          guest_type: body.guest_type,
          frequency: body.frequency,
          duration: body.duration,
          fund_value: body.fund_value,
          details: body.frequency === Duration.MONTH ? [{
            order: 1,
            fund_value: body.fund_value
          }] : body.details
        }
        body.guest_type = undefined;
        body.frequency = undefined;
        body.duration = undefined;
        body.fund_value = undefined;
        body.details = undefined;
        this.service.createItem('package/create', body).subscribe((res) => {
          this.modal.destroy(true)
        }, (error: any) => {
          this.service.handleError(error);
        });
      }
      if (this.mode === ItemMode.Edit) {
        body.promotion = {
          id: body.promotion_id,
          guest_type: body.guest_type || null,
          frequency: body.frequency || null,
          duration: body.duration || null,
          fund_value: body.fund_value || null,
          details: (this.objCache && body.frequency !== this.objCache.frequency ? (body.frequency === Duration.MONTH ? [{
            order: 1,
            fund_value: body.fund_value || null
          }] : body.details) : (
            body.details?.map((item: any) => {
              item.id = this.objCache.details.find((r: any) => r.order === item.order).id;
              return item;
            })
          ))
        }
        body.guest_type = undefined;
        body.frequency = undefined;
        body.duration = undefined;
        body.fund_value = undefined;
        body.details = undefined;
        body.promotion_id = undefined;
        this.service.updateItem(this.nzModalData.collection + '/update', body.id, body).subscribe(res => {
          this.modal.destroy(true)
        }, (error: any) => {
          this.service.handleError(error);
        });
      }
    } else {
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  addCost() {
    this.listCost.push({ apartment_type: null, price_by_owner: null, price_by_guest: null });
  }

  deleteCost(index: number) {
    if (this.listCost[index].id) {
      this.listCost[index]['deleted'] = DeleteStatus.YES;
      this.listCostDeleted.push(this.listCost[index])
    }
    setTimeout(() => {
      this.listCost.splice(index, 1);
      if (!this.listCost.length) {
        this.addCost();
      }
    }, 200);
  }

  addDataService() {
    this.listDataService.push({ service_id: null, revenue_split_rate: null });
  }

  deleteDataService(index: number) {
    if (this.listDataService[index].id) {
      this.listDataService[index]['deleted'] = DeleteStatus.YES;
      this.listDataServiceDeleted.push(this.listDataService[index])
    }
    setTimeout(() => {
      this.listDataService.splice(index, 1);
      if (!this.listDataService.length) {
        this.addDataService();
      }
    }, 200);
  }

  validateExistPackage() {
    let check = true;
    for (let i = 0; i < this.listCost.length; i++) {
      if (this.listCost.findIndex((r: any, index: number) => r.apartment_type === this.listCost[i].apartment_type && index !== i) !== -1) {
        check = false;
        break;
      }
    }
    return check;
  }

  validateExistService() {
    let check = true;
    for (let i = 0; i < this.listDataService.length; i++) {
      if (this.listDataService.findIndex((r: any, index: number) => r.service_id === this.listDataService[i].service_id && index !== i) !== -1) {
        check = false;
        break;
      }
    }
    return check;
  }

  validatePackage() {
    return this.listCost.filter((r: any) => !(r.apartment_type && r.price_by_owner !== null && r.price_by_guest !== null)).length === 0;
  }

  validateService() {
    return this.listDataService.filter((r: any) => !(r.service_id && r.revenue_split_rate !== null)).length === 0;
  }

  validateTable() {
    if (!this.validatePackage()) {
      this.noti.create('error', '', this.translateService.instant('service-package.error-required-cost'))
      return false;
    } else if (!this.validateExistPackage()) {
      this.noti.create('error', '', this.translateService.instant('service-package.error-exist-cost'))
      return false;
    } else if (!this.validateService()) {
      this.noti.create('error', '', this.translateService.instant('service-package.error-required-rate'))
      return false;
    } else if (!this.validateExistService()) {
      this.noti.create('error', '', this.translateService.instant('service-package.error-exist-rate'))
      return false;
    } else if (this.f['frequency'].value === this.Duration.PRECIOUS && this.f['details'].value.some((r: any) => r.fund_value < 0) &&
      this.f['fund_value'].value !== this.f['details'].value?.reduce((a: number, b: any) => a + b.fund_value, 0)) {
      this.noti.create('error', '', this.translateService.instant('service-package.error-invalid-fund'))
      return false;
    }
    return true;
  }

  onChangeNight(value: any, index: number) {
    const details = this.f['details'].value;
    details[index]['fund_value'] = value;
    const total = details.reduce((a: number, b: any) => a + (b.fund_value ?? 0), 0);
    this.f['fund_value'].setValue(total, { emitEvent: false });
  }
}
